/*
 * Public API Surface of common
 */

export * from './lib/common.module';
